import { ScrollView, View } from 'react-native';
import { HelperText, IconButton, Text, useTheme } from "react-native-paper";
import { Avatar } from "react-native-paper";
import React, { useEffect, useRef, useState } from "react";
import Global from '../constants/global';
import ReactToPrint from 'react-to-print';
import { MaterialIcons } from '@expo/vector-icons';
import { useSelector } from 'react-redux';

const pageStyle = `
  @page {
    size: A4;
    margin: 0; /* We will handle margins inside the component */
  }
  @media print {
    body { -webkit-print-color-adjust: exact; }
    .page-container {
      height: 148mm; /* Half of A4 (297mm / 2) */
      overflow: hidden;
      box-sizing: border-box;
      border-bottom: 1px dashed #ccc; /* Cutting guide */
    }
    .break-after {
      page-break-after: always;
    }
  }
`;

export default function Marksheet({ navigation, route }) {
    // const marks = useSelector(s => s.list.Marksheets)
    const marks = useSelector(s => s.list.Marksheets[route.params.classId + route.params.year + route.params.examName])
    const [list, setList] = useState([])
    useEffect(() => {
        if (marks) {
            // //console.log(marks)
            if (route.params.id) {
                const l = []
                l.push(marks[route.params.id])
                setList(l)
            } else {
                if (route.params.list) {
                    const l = []
                    route.params.list.map(i => {
                        const id = typeof i == "string" ? i : i?.id
                        if (marks[id]) {
                            l.push(marks[id])
                        }
                    })
                    setList(l)
                }
            }
        }
    }, [marks])
    // const exam = route?.params?.exam
    // const year = route.params.year
    const ht = 27
    const bw1 = 3
    const bw2 = 2
    const ref = useRef()
    const t = useTheme()
    let pg1 = 2

    return <ScrollView horizontal style={{ flex: 1, alignSelf: "stretch", }}>
        <View style={{ minWidth: 700 }}>
            {route?.params?.blockPrint !== true && <View style={{ flexDirection: "row" }}>
                <IconButton icon="arrow-left" style={{}} onPress={() => navigation.goBack()} />
                <ReactToPrint
                    pageStyle={pageStyle}
                    trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                    content={() => ref.current}
                />

            </View>}
            <div ref={ref} style={{ width: '210mm' }}>

                {list.map((value, i) => {
                    pg1 = pg1 == 2 ? 1 : 2
                    let cnd = 0
                    const isSecondOnPage = (i + 1) % 2 === 0;
                    const isLastItem = (i + 1) === list.length;
                    const PASS = value?.status == "Pass"
                    return <div key={i}
                        className={`page-container ${isSecondOnPage && !isLastItem ? 'break-after' : ''}`}
                        style={{
                            width: "210mm",
                            height: "148mm", // Forces the height to be exactly half an A4
                            padding: "10mm",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "white",
                            boxSizing: "border-box",
                            position: "relative"
                        }}>
                        <div style={{
                            width: '100%',
                            borderWidth: bw1,
                            borderStyle: "solid",
                            flex: 1, // Let the content fill the half-page
                            display: "flex",
                            flexDirection: "column"
                        }}>
                            <div style={{ display: "flex", position: "relative", flexDirection: "column", backgroundColor: t.dark ? "transparent" : "#DCDCDC", borderBottomWidth: bw2, borderBottomStyle: "solid", alignItems: "center", justifyContent: "center" }}>

                                <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                    <Avatar.Image style={{ marginTop: 5, marginEnd: 10 }} size={60} source={{ uri: require("../assets/images/LOGO.jpg") }} />
                                    <View>
                                        <Text variant="headlineMedium" style={{ color: "black", fontWeight: "900", marginTop: 10 }}>શ્રી ઠક્કરબાપા વિદ્યામંદિર</Text>
                                        <Text variant="titleMedium" style={{ color: "black", paddingLeft: 10 }}>ઠક્કરબાપાનગર, અમદાવાદ-૩૮૨૩૫૦</Text>
                                    </View>
                                </View>
                                <View style={{ alignItems: "center", justifyContent: "center", flex: 1, flexDirection: "row" }}>
                                    <Text variant="titleLarge" style={{ textAlign: "center", color: "black" }}>{value?.examName} પરિણામ</Text>
                                    <Text variant="titleLarge" style={{ textAlign: "center", color: "black" }}> (વર્ષ : {value?.year}) </Text>
                                </View>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", marginTop: 5, marginLeft: 10 }}>
                                <View style={{ flex: 1, flexDirection: "row" }}>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{ color: "black" }}>વિદ્યાર્થી નું નામ   :   </Text>
                                        <Text variant="titleMedium" style={{ color: "black", fontWeight: "900", textDecorationLine: "underline" }}>{value?.name}</Text>
                                    </View>
                                    <View style={{ flex: 1 }}>
                                        <Text variant="titleMedium" style={{ color: "black", marginBottom: 10, flex: 1, fontWeight: "900" }}>{value?.class} {value?.div}</Text>
                                    </View>
                                </View>
                                <View style={{ flex: 1, flexDirection: "row" }}>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{ color: "black" }}>રોલ નં - {value?.roll}</Text>
                                        <Text variant="titleMedium" style={{ color: "black" }}>               GR નં - {value?.gr}</Text>
                                    </View>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{ color: "black", flex: 1 }}>UID નં - {value?.uid}    </Text>
                                    </View>
                                </View>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <View style={{ width: "70%", alignSelf: "stretch", borderRightWidth: 2, borderStyle: "solid" }}>
                                    <View style={{ alignItems: "center", justifyContent: "center", paddingLeft: 5, backgroundColor: t.dark ? "transparent" : "#DCDCDC", flexDirection: "row", borderTopWidth: bw2, borderStyle: "solid", borderBottomWidth: bw2 }}>
                                        <View style={{ height: (ht * 1.25), flex: 3, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleMedium" style={{ textAlign: "center", color: "black" }}>અ.નં</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 20, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleMedium" style={{ textAlign: "center", color: "black" }}>વિષય</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 5, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center", color: "black" }}>કુલ ગુણ</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", borderRightWidth: bw2, }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center", color: "black" }}>મેળવેલ ગુણ</Text>
                                        </View>
                                        {value?.final && <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", borderRightWidth: bw2, }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center", color: "black" }}>સિદ્ધિ ગુણ</Text>
                                        </View>}
                                        {value?.final && <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center", color: "black" }}>કૃપા ગુણ</Text>
                                        </View>}
                                    </View>
                                    {

                                        value?.marks?.map((subject, sr) => {
                                            let showM = subject.selfMarks ? subject.selfMarks : subject?.theory
                                            showM = Global.getDoubleZero(showM)

                                            const toShow = (subject?.totalMarks > 0 || subject?.grad)
                                            cnd = toShow ? cnd + 1 : cnd
                                            return (
                                                toShow ? <View style={{ alignItems: "center", justifyContent: "center", paddingLeft: 5, flexDirection: "row", borderBottomWidth: bw2, borderStyle: "solid" }}>
                                                    <View style={{ height: ht, flex: 3, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ textAlign: "center", color: "black" }}>{cnd}</Text>
                                                    </View>

                                                    <View style={{ height: ht, flex: 20, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ textAlignVertical: "center", overflow: "hidden", fontWeight: subject?.name?.replace(/[^a-zA-Z0-9]/g, "")?.includes("SPCC") ? "bold" : "normal", color: "black" }}> {subject.name}</Text>
                                                    </View>
                                                    <View style={{ height: ht, flex: 5, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ fontWeight: "900", textAlignVertical: "center", textAlign: "center", color: "black" }}> {subject.totalMarks}</Text>
                                                    </View>

                                                    <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", borderRightWidth: bw2, }}>
                                                        <Text variant="titleMedium" style={{ fontWeight: "900", textAlign: "center", textDecorationLine: subject.status == "Fail" ? "underline" : "none", color: "black" }}>
                                                            {subject?.grad ? subject?.grade : showM}</Text>
                                                    </View>
                                                    {value?.final && <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", borderRightWidth: bw2, }}>
                                                        {(PASS && !subject.grad && subject.siddhi) ? <Text variant="bodyMedium" style={{ fontWeight: "bold", color: "red", padding: 0 }}>
                                                            {(subject.siddhi ? "+" + subject.siddhi : "")}</Text> : <></>}
                                                    </View>}
                                                    {value?.final && <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", }}>
                                                        {(PASS && !subject.grad && subject.kripa) ? <Text variant="bodyMedium" style={{ fontWeight: "bold", color: "green", padding: 0 }}>
                                                            {(subject.kripa ? "+" + subject.kripa : "")}</Text> : <></>}
                                                    </View>}
                                                </View> : <></>)
                                        })
                                    }
                                    <View style={{ backgroundColor: t.dark ? "transparent" : "#DCDCDC", paddingLeft: 5, flexDirection: "row", borderBottomWidth: bw2 }}>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 23, textAlign: "center", borderRightWidth: bw2, borderStyle: "solid", color: "black" }}>કુલ ગુણ</Text>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 5, textAlign: "center", borderRightWidth: bw2, borderStyle: "solid", color: "black" }}>{value?.totalMarks}</Text>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, textAlign: "center", borderRightWidth: bw2, color: "black" }}>{value?.totalGained}</Text>
                                        {/* <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, textAlign: "center", borderRightWidth: bw2, color:"black" }}>{exam?.selfMarks ? exam?.selfMarks : (exam?.subjectMarks ? exam?.subjectMarks : "0")}</Text>
                                        {exam?.final && <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, color: "red", textAlign: "center", borderRightWidth: bw2, color:"black" }}>{(exam?.status == "Pass" && exam?.siddhiGiven) ? "+" + exam?.siddhiGiven : ""}</Text>}
                                        {exam?.final && <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, color: "green", textAlign: "center", color:"black" }}>{(exam?.status == "Pass" && exam?.kripaGiven) ? "+" + exam?.kripaGiven : ""}</Text>} */}
                                    </View>
                                </View>
                                <View style={{ width: "30%", borderTopWidth: bw2, borderBottomWidth: bw2, alignItems: "center", justifyContent: "center" }}>
                                    <View style={{ flexDirection: "row", borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                        <View style={{ justifyContent: "center", alignItems: 'center' }}>
                                            <Text style={{ color: "black", height: 35 }} variant="titleMedium">પરિણામ </Text>
                                            <Text style={{ color: "black", height: 35 }} variant="titleMedium">ટકાવારી </Text>
                                            <Text style={{ color: "black", height: 35 }} variant="titleMedium">પાસ નંબર </Text>
                                        </View>

                                        <View style={{ justifyContent: "center", alignItems: 'center', borderWidth: bw1, borderStyle: "solid", }}>
                                            <Text variant="titleMedium" style={{ color: "black", height: 35, borderBottomWidth: bw1, fontWeight: "900", textAlign: "center", width: 100, }}>{value?.status}</Text>
                                            <Text variant="titleMedium" style={{ color: "black", height: 35, borderBottomWidth: bw1, fontWeight: "900", borderStyle: "solid", width: 100, textAlign: "center" }}> {PASS ? (value?.pc ? value?.pc + " %" : "") : "-"} </Text>
                                            <Text variant="titleMedium" style={{ color: "black", height: 35, fontWeight: "900", borderStyle: "solid", width: 100, textAlign: "center" }}> {PASS ? (value?.rank ? value?.rank + "" : "-") : "-"}  </Text>
                                        </View>
                                    </View>
                                    {value?.final && <View style={{ flexDirection: "row", borderStyle: "solid", alignItems: "center", justifyContent: "center", marginTop: 30 }}>
                                        <View style={{ justifyContent: "center", alignItems: 'center' }}>
                                            {/* <Text style={{ flex: 1 }} variant="titleMedium">{chk["class" + route.params?.year]?.totalDays}</Text> */}
                                            <Text style={{ color: "black", flex: 1, borderTopWidth: 1 }} variant="titleMedium">કુલ દિવસ</Text>
                                        </View>
                                        <Text style={{ color: "black", flex: 1 }} variant="titleSmall"> માંથી </Text>

                                        <View style={{ justifyContent: "center", alignItems: 'center', borderStyle: "solid", }}>
                                            <Text style={{ color: "black", flex: 1 }} variant="titleMedium">{chk["class" + route.params?.year]?.present}</Text>
                                            <Text style={{ color: "black", flex: 1, borderTopWidth: 1 }} variant="titleMedium">હાજર દિવસ</Text>
                                        </View>
                                    </View>}

                                    <Text style={{ color: "black", textDecorationLine: "underline", fontWeight: "bold", marginTop: 20 }}>{value?.note1}</Text>

                                </View>
                            </div>
                            {route?.params?.blockPrint !== true &&
                                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                                    <div style={{ display: "flex", marginTop: 30, flex: 1, flexDirection: "row" }}>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ color: "black", flex: 1, textAlign: "center", fontWeight: "bold" }}>વર્ગશિક્ષકની  સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ color: "black", flex: 1, textAlign: "center", fontWeight: "bold" }}>ચેકરની સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ color: "black", flex: 1, textAlign: "center", fontWeight: "bold" }}>આચાર્યની સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                    </div>

                                    {value?.final && <Text style={{ color: "black" }}>{route.params?.exam?.note1}</Text>}
                                    {value?.note2 && <Text style={{ color: "black", marginTop: 5, marginBottom: 5, flex: 1, textAlign: "center" }}>{value.note2}</Text>}
                                </div>
                            }
                        </div>
                        {pg1 == 2 && <div className="pagebreak" />}
                    </div>
                })}
            </div>
        </View>
    </ScrollView>
}